import React, { useContext, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import { useField } from 'react-final-form';
import {
  Header1SemiBold,
  Header3SemiBold,
  SelectField as BaseSelectField,
  header1,
  Chip,
  Flex,
  small
} from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import suggestedPositions from './positions';

const Title = styled(Header1SemiBold)`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.black};
`;

const SubTitle = styled(Header3SemiBold)`
  margin-bottom: 50px;
  color: ${({ theme }) => theme.colors.black};
`;

const SelectField = styled(BaseSelectField)`
  .select {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
    box-shadow: none;

    .select-label,
    .select-input {
      ${header1};
      padding: 0;
    }
  }

  .select-chip {
    display: none;
  }
`;

const Chips = styled(Flex)`
  width: 500px;
  overflow: auto;
  flex-wrap: wrap;
  > div {
    margin: 10px 10px 0 0;
    ${small}

    > svg > path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

const Spacer = styled.div`
  flex: 1;
  margin-bottom: 60px;
`;

const DefinePositions = () => {
  const { t } = useContext(ConfigContext);
  const theme = useTheme();

  const {
    input: { value: positions, onChange: handleChangePositions }
  } = useField('positions');

  const positionsOptions = useMemo(
    () =>
      (suggestedPositions || [])
        // .filter(({ industries }) => industries.includes(industryId))
        .map((value) => ({ value, label: value })),
    []
  );

  const positionsChips = useMemo(
    () =>
      (positions || []).map((slug) => ({
        value: slug,
        label: slug
      })),
    [positions]
  );

  return (
    <>
      <Title>{t('definePositionsTitle')}</Title>
      <SubTitle>{t('definePositionsSubTitle')}</SubTitle>

      <SelectField name="positions" options={positionsOptions} placeholder={t('addTeamPositions')} creatable />

      <Chips>
        {positionsChips.map(({ value, label }, index) => (
          <Chip
            key={index}
            label={label}
            color={theme.colors.white}
            background={theme.colors.primary}
            onRemove={() => handleChangePositions(positions.filter((position) => position !== value))}
          />
        ))}
      </Chips>

      <Spacer />
    </>
  );
};

export default DefinePositions;
